import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '../../../../core/Button/Button.jsx';

function CanceledTournamentButton({ desktopRequire = false }) {
    const { t } = useTranslation();
    const isMobile = useSelector((state) => state.user.isMobile);

    // Desktop version button
    const desktopButton = (
        <div className="button-size">
            <Button
                type="blue-border"
                text={t('tournament.canceled')}
                onClick={() => {}}
            />
        </div>
    );

    if (desktopRequire) {
        return desktopButton;
    }

    return isMobile ? <i className="icon-information"/> : desktopButton;
}

export default CanceledTournamentButton;

